export const environment = {
    production: false,
    baseUrl: "https://bp-qa-apim.azure-api.net/pf-qa/",
    baseUrlRbac: "https://pf-bp-infra-rbac-service-dev.azurewebsites.net/",
    tenantId: 'c7a5f66f-bb53-4063-8756-c9b349410aa8',
    appId: 'MCL-DEV',
    auth0:{
        domain: "bluepondai.us.auth0.com",
        clientId: "fQOWIFtEjMguSEtNEIbmohCHUuhzI7vQ",
        audience: "bp-platform.ai"
    },
    mclFeatures: false,
};
